// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--G_VUR","container":"container--eU1Wj","list":"list--f9ZXo","fadeSlideUp":"fadeSlideUp--tVOD6"};